import joi from 'joi';

import type { GraphUrlId, GraphView, WithUserDetails } from '../graphView';
import type { WithSnapshot } from '../snapshot';
import {
  type GraphViewRequestBodyBase,
  graphViewRequestBodyBaseSchema,
} from './GraphView';

export interface GraphUrlRequestBody extends WithSnapshot {
  graphView: GraphViewRequestBodyBase;
}

export interface GraphUrlResponseBody extends WithUserDetails, WithSnapshot {
  id: GraphUrlId;
  graphView: GraphView;
}

export const graphUrlRequestBodySchema = joi.object().keys({
  snapshot: joi.string().required(),
  graphView: graphViewRequestBodyBaseSchema.required(),
});
